<template>
    <div class="saleCredit">
<!--        <el-card>-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>销售管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>赊销额度</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司">
                        <el-select v-model="searchForm.companyId" filterable clearable placeholder="请选择公司" size="mini">
                            <el-option v-for="item in companyOptions" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table stripe :data="tableData" size="mini" v-loading="loading" style="width: 100%" :height="tableConfig.height">
                    <el-table-column prop="companyName" label="公司名称"></el-table-column>
                    <el-table-column prop="availableBalance" label="可用额度" width="100">
                        <template slot-scope="scope">
                            <span v-if="!scope.row.availableBalance">-</span>
                            <span v-if="scope.row.availableBalance">{{ scope.row.availableBalance }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="350" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="handleShowDialog(scope.row)">增加额度</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination background layout="sizes,prev, pager, next"
                                   :page-sizes="[10, 20, 50, 100]" v-if="total>0" :total="total"
                        :page-size="pageSize" @current-change="onPageChange"
                                   :current-page="currentPage"
                                   @size-change="handleSizeChange"
                                   @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="增加额度" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <div style="color:red;padding: 0 0 10px 10px">额度更新可能有延迟，如添加后额度未更新，请稍后刷新确认</div>
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="公司名称" prop="companyName">
                    <el-input v-model="editForm.companyName" placeholder="请输入公司名称" disabled clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="部门名称" prop="departmentName">
                    <el-input v-model="editForm.departmentName" placeholder="请输入部门名称" disabled clearable></el-input>
                </el-form-item> -->
                <el-form-item label="额度" prop="changeBalance">
                    <el-input v-model="editForm.changeBalance" placeholder="请输入增加的额度" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onPreSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const HEIGHT_OFFSET = 118;
export default {
    data() {
        return {
            pageLoading: undefined,
            tableConfig: {
                height: 0,
            },
            companyOptions: [], // 公司选项
            searchForm: {
                companyId: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            editForm: {
                id: "",
                companyName: "",
                // departmentName: "",
                changeBalance: 0,
            },
            rules: {
                name: [
                    { required: true, message: '请输入询价单名称', trigger: 'blur' }
                ],
                userId: [
                    { required: true, message: '请选择用户', trigger: 'blur' }
                ]
            },
        }
    },
    methods: {
        initCompanyOption() {
            let that = this;
            this.$axios.post("/admin/company/list", {}).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.companyOptions = resp.data;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        onSearch() {
            let that = this;
            this.$axios.post("/admin/finance/creditLimit/page", {
                ...this.searchForm,
                page: this.currentPage - 1,size:this.pageSize,
            }).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.tableData = resp.data.content;
                    that.total= resp.data.totalElements;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleShowDialog(row) {
            this.editForm = {
                id: row["id"],
                companyName: row["companyName"],
                // departmentName: row["departmentName"],
                changeBalance: 0,
            };
            this.editDialogVisible = true;
        },
        onPreSubmit() {
            const { id, companyName, changeBalance } = this.editForm;
            this.$confirm(`此操作将为[${companyName}]增加[${changeBalance}元]赊销额度, 是否确定?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let that = this;
                this.$axios.post("/admin/finance/creditLimit/bookkeeping", {
                    id,
                    amount: changeBalance,
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.onSearch();
                        that.editDialogVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            }).catch(() => {
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        this.initCompanyOption();
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
        this.pageLoading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoading.close();
            this.pageLoading = undefined;
        }, 500);
    },
    beforeDestroy() {
        if(this.pageLoading){
            this.pageLoading.close();
            this.pageLoading = undefined;
        }
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>
<style></style>
